import * as Yup from 'yup'

export const landlineValidation = Yup.string()
  .matches(/^[0-9]*$/, 'Only digits 0-9 are allowed.')
  .matches(/^$|^.{8,}$/, 'Field must be either empty or at least 8 digits long')

export const alphaNumericValidation = Yup.string()
  .required('required')
  .matches(/(^$)|(^[a-zA-Z0-9]+$)/, 'Only alpha-numeric characters are allowed')

export const Name = Yup.string().trim().min(1, 'Too Short Name!').max(50, 'Too Long Name!').required('Required')

export const addressValidation = Yup.string()
  .trim()
  .min(1, 'Too Short Address!')
  .max(50, 'Too Long Address!')
  .required('Required')
export const optionalAddressValidation = Yup.string().trim().max(50, 'Too Long Address!').nullable().optional()

export const accountNoValidation = Yup.string()
  .required('required')
  .matches(/(^$)|(^[a-zA-Z0-9]+$)/, 'Only alpha-numeric characters are allowed')
  .min(1, 'Too Short Account No!')
  .max(30, 'Too Long Account!')

export const confirmAccountNoValidation = Yup.string()
  .required('required')
  .matches(/(^$)|(^[a-zA-Z0-9]+$)/, 'Only alpha-numeric characters are allowed')
  .test('accountNoConfirmation', 'Account No. and Confirm Account No. Mismatch', function (value, ...extraData) {
    const { settlementAccountNumber } = this.parent
    return !settlementAccountNumber || settlementAccountNumber === value
  })

export const webAddressValidation = Yup.string()
  .trim()
  .min(1, 'Too Short Website Address!')
  .max(50, 'Too Long Website Address!')
  .required('Required')

export const hideNonExistantFields = (key: string) => (values: any) => !values?.[key]
